import React, { useState } from 'react';
import '../../styles/LoginPage.css';
import { useNavigate } from 'react-router-dom';
import { fetchSubscriptionLoginUserApi } from '../../api/api';
import { jwtDecode } from "jwt-decode";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const getTokenExpireTime = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (decoded.exp) {
        return decoded.exp * 1000;
      }
      return null;
    } catch (error) {
      console.error("Invalid token:", error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }

    const response = await fetchSubscriptionLoginUserApi(email, password);

    if (response.statuscode === 200) {
      const token = response.data.token;
      const expiryTime = getTokenExpireTime(token);

      if (expiryTime) {
        sessionStorage.setItem("tokenId", token);
        sessionStorage.setItem("expiryId", expiryTime.toString());
        sessionStorage.setItem("subscriptionid", response.data.subscriptionid);

        navigate('/');
      } else {
        setError("Invalid token received");
      }
    } else if (response.statuscode === 404) {
      setError(response.message);
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        {error && <p className="error">{error}</p>}

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </div>

        <div className="form-group password-group">
          <label>Password </label>
          <div className="password-wrapper-login">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <span
              className="password-toggle-login"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                // 👁 eye icon
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" width="20" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 
                      2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 
                      0-8.268-2.943-9.542-7z" />
                </svg>
              ) : (
                // 👁‍🗨 eye-off icon
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" width="20" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                    d="M2 12C3.5 7 7.5 4 12 4s8.5 3 10 8c-1.5 5-5.5 8-10 8s-8.5-3-10-8z" />
                  <circle cx="12" cy="12" r="3" strokeWidth="2" stroke="currentColor" fill="none"/>
                  <line x1="4" y1="20" x2="20" y2="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              )}
            </span>
          </div>
        </div>

        <button type="submit">Login</button>
        <div className="forgot-password">
          <button
            type="button"
            className="forgot-password-btn"
            onClick={() => navigate('/forgot-password')}
          >
            Forgot Password
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
